import { AbstractControl, ValidatorFn } from '@angular/forms';

export default function isNumberValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    return control.value !== null && control.value.length !== 0 && !isNaN(control.value) ? null : { isNumber: true };
  };
}



// WEBPACK FOOTER //
// ./src/validators/isNumberValidator.ts